import { valueToBRL } from '../../../utils/formatCoin';

import style from './conceito.module.scss';

const parse = require('html-react-parser');

export default function Conceito({
  conceito, valorMinimo, valorMaximo, faseObra,
}) {
  if (!conceito) return null;

  return (
    <div className={style.section}>
      {parse(conceito)}
      {faseObra !== 'Pré-lançamento' && (
        <p className={style.preco}>
          <span>{`Unidades a partir de ${valueToBRL(valorMinimo)} até ${valueToBRL(valorMaximo)}`}</span>
        </p>
      )}
      {faseObra !== 'Pré-lançamento' && <h5>Os preços das unidades podem variar conforme disponibilidade e data de consulta.</h5>}
    </div>
  );
}
